"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = void 0;
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var responsiveProp_1 = __importDefault(require("../responsiveProp"));
var DEFAULT_ELEMENT = 'div';
exports.Grid = react_1.default.forwardRef(function AOGrid(_a, ref) {
    var children = _a.children, className = _a.className, _b = _a.as, ElementType = _b === void 0 ? DEFAULT_ELEMENT : _b, noGutter = _a.noGutter, reverse = _a.reverse, column = _a.column, equalHeight = _a.equalHeight, vAlign = _a.vAlign, hAlign = _a.hAlign, props = __rest(_a, ["children", "className", "as", "noGutter", "reverse", "column", "equalHeight", "vAlign", "hAlign"]);
    return (react_1.default.createElement(ElementType, __assign({ className: classnames_1.default('flex flex-wrap', !noGutter && '-m-2', column && responsiveProp_1.default(column, function () { return 'flex-col'; }), reverse &&
            responsiveProp_1.default(reverse, function () { return "flex-" + (column ? 'col' : 'row') + "-reverse"; }), column
            ? [hAlign && "items-" + hAlign, vAlign && "justify-" + vAlign]
            : [vAlign && "items-" + vAlign, hAlign && "justify-" + hAlign], className), "data-aods": "grid" }, props, { ref: ref }), noGutter
        ? children
        : react_1.default.Children.map(children, function (child) {
            return react_1.default.isValidElement(child)
                ? react_1.default.cloneElement(child, {
                    className: classnames_1.default('p-2', { flex: equalHeight }, child.props.className),
                })
                : child;
        })));
});
exports.default = exports.Grid;
//# sourceMappingURL=Grid.js.map